// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"131":"fcf2cd11","213":"9721a396","650":"f7aaf2a9","667":"ef22a885"}[chunkId] + ".chunk.js";
};